import { z } from "zod";

export type Timespan = {
  startDate: Date | null;
  endDate: Date | null;
};

export const PeriodOptionSchema = z.enum([
  "custom",
  "last_day",
  "last_7_days",
  "last_28_days",
  "last_18_months",
  "prev_month",
]);

export type PeriodOptionType = z.infer<typeof PeriodOptionSchema>;
